/**
 * Return the Cookie raw state
 */
import cookie from 'cookiejs';
import { cookieBaseDomain } from '/shared/util/Statics';

// Define preference statics
const cookiePreferenceName = 'cmp-cookie-prefs';
const cookiePreferencesDefault = {
  confirmed: false,
  performance: true,
  hotjar: null,
};

type CookiePreferences = {
  confirmed: boolean;
  performance: boolean;
  hotjar: boolean | null;
};

const loadCurrentCookie = (): Partial<CookiePreferences> => {
  let ret: Partial<CookiePreferences> = {};
  try {
    const cookieLoad = cookie.get(cookiePreferenceName);
    if (typeof cookieLoad === 'string') {
      ret = JSON.parse(cookieLoad) as Partial<CookiePreferences>;
    }
  } catch (e) {
    // Do nothing
  }
  return ret;
};

const getCookiePreferences = (): CookiePreferences => {
  const currentCookiePreferences = loadCurrentCookie();
  return {
    ...cookiePreferencesDefault,
    ...currentCookiePreferences,
  };
};

// Define setting the payload
const setPreferencePayload = (payload: Partial<CookiePreferences> | null = {}) => {
  if (payload === null) {
    // Delete preference cookie
    cookie.set(cookiePreferenceName, '', {
      path: '/',
      domain: cookieBaseDomain,
      expires: -1,
      secure: true,
    });
  } else {
    const finalPreferences = { ...getCookiePreferences(), ...payload, confirmed: true };
    cookie.set(cookiePreferenceName, JSON.stringify(finalPreferences), {
      path: '/',
      domain: cookieBaseDomain,
      expires: 7, // 1 week
      secure: true,
    });
    if (!finalPreferences.hotjar) {
      cookie.set('_hjOptOut', 'true', {
        path: '/',
        expires: 7, // 1 week
        domain: cookieBaseDomain,
        secure: true,
      });
      const safeCookieNames = ['cmp-cookie-prefs', '_hjOptOut'];
      const existingCookieObject = cookie.all();
      const toRemoveCookieNames = Object.keys(existingCookieObject).filter((cookieName) => {
        return !safeCookieNames.includes(cookieName);
      });
      if (toRemoveCookieNames.length > 0) {
        cookie.remove(toRemoveCookieNames);
      }
    } else {
      cookie.set('_hjOptOut', '', {
        path: '/',
        domain: cookieBaseDomain,
        expires: -1,
        secure: true,
      });
      // reload to ensure GA + HJ update for opt-in
      window.location.reload();
    }
  }
};

export {
  cookiePreferenceName,
  setPreferencePayload,
  cookiePreferencesDefault,
  getCookiePreferences,
  loadCurrentCookie,
};
